import { MainPanel } from "@utdanningsdirektoratet/layout";
import DocumentMetadata from "../../components/DocumentMetadata";
import HoeringsFooter from "../../components/Footer";
import { institusjonNavnLang } from "../../logic/initialState";

const Personvern = () => {
  return (
    <>
      <DocumentMetadata title={institusjonNavnLang} />
      <div className="Grid">
        <div className="Page">
          <MainPanel
            color="white"
            fullwidth
            className="Page-section u--marginTop4"
          >
            <h1 className="Page-title u-h1">
              Personvernerklæring for Høringssystemet
            </h1>
            <p>
              Høringssystemet er Utdanningsdirektoratets verktøy for
              gjennomføring av offentlige høringer, i tråd med
              utredningsinstruksen.
            </p>

            <h2 className="u-h2">Hvorfor vi behandler personopplysninger</h2>
            <p>
              Utdanningsdirektoratets behandlingsgrunnlag er allmenhetens
              interesse og utøvelse av offentlig myndighet, jf.
              personvernforordningen art. 6 nr. 1 bokstav e, jf.
              Utredningsinstruksen § 3-3, jf. kongelig resolusjon 19. februar
              2016 med hjemmel i instruksjonsmyndigheten.
            </p>

            <h2 className="u-h2">Personopplysninger som behandles</h2>
            <p>
              Utdanningsdirektoratet er ansvarlig for behandling av følgende
              personopplysninger i systemet: Innsenders navn, e-postadresse,
              IP-adresse, eventuelt arbeidssted og -stilling. Høringsuttalelser
              er offentlig informasjon og vi publiserer høringsuttalelser
              fortløpende på udir.no. Derfor skal du ikke oppgi annen personlig
              eller sensitiv informasjon i ditt høringssvar. Vi sammenstiller
              også høringsuttalelsene i en rapport for videre saksbehandling
              etter endt høring. Høringsuttalelser er underlagt
              journalføringsplikt og publiseres i fulltekst til innsynsportalen
              eInnsyn.no.
            </p>

            <h2 className="u-h2">Hvem har tilgang til personopplysninger</h2>
            <p>
              Utdanningsdirektoratet drifter og utvikler Høringssystemet med
              bistand fra leverandør, Bekk Consulting AS. Som drifter av
              systemet vil Utdanningsdirektoratet og leverandør kunne ha tilgang
              til personopplysninger i systemet. Leverandør er bundet av
              taushetserklæringer og databehandleravtaler. Systemet driftes
              internt i Utdanningsdirektoratet og kjører i Microsoft Azure i
              Vest-Europa. Vi bruker Twilio Sendgrid til utsending av
              bekreftelseseposter, og din e-postadresse kan overføres til USA.
              Twilio er godkjent under Data Privacy Framework.
            </p>

            <h2 className="u-h2">Lagring og sletting av personopplysninger</h2>
            <p>
              Høringsuttalelser skal bevares for ettertiden. Derfor arkiverer vi
              dem, inkludert de opplysningene du har registrert om deg selv i
              forbindelse med innsending, jf. arkivloven § 1. Dersom du har
              sendt inn høringsuttalelse ved en feil, ønsker å trekke uttalelsen
              din eller vil gjøre endringer, kan du gi oss beskjed til{" "}
              <a href="mailto:post@udir.no">post@udir.no</a>. Du kan finne og
              laste ned høringsuttalelsene dine på udir.no i tre år etter at
              høringsfristen har utløpt. Etter dette er de ikke lenger
              tilgjengelige på nettsidene våre og du kan be om innsyn til{" "}
              <a href="mailto:post@udir.no">post@udir.no</a>, eventuelt søke opp
              uttalelsene på eInnsyn.no. Vi avleverer høringsuttalelser til
              Arkivverket for langtidslagring.
            </p>

            <h2 className="u-h2">Informasjonskapsler</h2>
            <p>
              Høringssystemet bruker informasjonskapsler (cookies) for å lagre
              din påbegynte uttalelse, slik at du kan fortsette arbeidet neste
              gang du åpner høringen. Vi bruker også informasjonskapsler for å
              samle inn anonymiserte data for å analysere bruksmønsteret på
              nettsiden. De anonymiserte dataene inkluderer informasjon om
              operativsystem, nettleser, digital enhet, hvilke lenker du klikker
              på og din geografiske plassering ned til nærmeste by.
              Utdanningsdirektoratet, leverandør og vårt analyseverktøy har
              tilgang til informasjonen. Informasjonen kan ikke brukes til å
              spore deg. Dersom du ikke ønsker at vi skal samle inn denne
              informasjonen, kan du skru av statistiske informasjonskapsler ved
              å klikke på «informasjonskapsler» lengst ned på siden og endre
              innstillingene.
            </p>

            <h2 className="u-h2">Hvis du har spørsmål</h2>
            <p>
              Har du spørsmål knyttet til behandling av dine personopplysninger
              i Høringssystemet, kan du ta kontakt med{" "}
              <a href="mailto:personvernombudet@udir.no">
                personvernombudet@udir.no
              </a>
              . Du har rett til å klage til Datatilsynet. Informasjon om dette
              finner du på <br />
              <a href="https://www.datatilsynet.no/om-datatilsynet/kontakt-oss/klage-til-datatilsynet/">
                https://www.datatilsynet.no/om-datatilsynet/kontakt-oss/klage-til-datatilsynet/
              </a>
            </p>
          </MainPanel>
        </div>
      </div>
      <HoeringsFooter />
    </>
  );
};

export default Personvern;
